import React, { useState } from 'react'
import logoImg from './../assets/image/new_logo.png';
import logoImg2 from './../assets/image/logo2.png';
import audiosumLogo from './../assets/image/audiosum.png';

function Logo({ width = 'auto', name=true, className='', maxWidth, maxHeight }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleLogoClick = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  return (
    <>
    {name ? 
      <>
        {/* Desktop Logo - Full logo with pulsating effect and click to expand */}
        <div 
          onClick={handleLogoClick}
          style={{ 
            cursor: 'pointer',
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '15px'
          }}
          className="logo-container"
        >
          <style>{`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.05);
              }
            }

            .logo-pulsating {
              animation: pulse 2s ease-in-out infinite;
            }

            .logo-expanded {
              animation: expandLogo 0.4s ease-out forwards;
            }

            .logo-collapsed {
              animation: collapseLogo 0.3s ease-out forwards;
            }

            @keyframes expandLogo {
              0% {
                opacity: 0;
                transform: translateX(-30px) scale(0.8);
              }
              100% {
                opacity: 1;
                transform: translateX(0) scale(1);
              }
            }

            @keyframes collapseLogo {
              0% {
                opacity: 1;
                transform: translateX(0) scale(1);
              }
              100% {
                opacity: 0;
                transform: translateX(-30px) scale(0.8);
              }
            }

            .desktop-logo {
              display: block;
            }

            .mobile-logo {
              display: none;
            }

            @media (max-width: 768px) {
              .desktop-logo {
                display: none;
              }
              .mobile-logo {
                display: block;
              }
            }
          `}</style>
          
          <img 
            src={logoImg} 
            className={`${className} desktop-logo logo-pulsating`}
            style={{ 
              maxHeight: maxHeight ?? '50px', 
              width: width, 
              maxWidth: maxWidth ?? '',
              transition: 'all 0.3s ease'
            }} 
            alt="Audiosum AI" 
          />
          
          {/* Expanded Audiosum Logo - Horizontally to the right */}
          {isExpanded && (
            <img 
              src={audiosumLogo}
              className="desktop-logo logo-expanded"
              style={{ 
                maxHeight: '35px',
                width: 'auto',
                transition: 'all 0.3s ease'
              }}
              alt="Audiosum Full Logo"
            />
          )}
          
          {/* Mobile Logo - Icon only */}
          <img 
            src="/logo.png" 
            className={`${className} mobile-logo logo-pulsating`}
            style={{ height: '40px', width: 'auto' }} 
            alt="Audiosum AI" 
          />
        </div>
      </>
      :
      <img src={logoImg2} style={{ maxHeight: maxHeight ?? '24px', width: { width }, maxWidth: maxWidth ?? '24px' }} alt="" />  
    }
    </>
  )
}
export default Logo